import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'components/main/App';
import * as _ from 'global';
import { isHttpClientApiError } from 'utils/httpClient';

window.addEventListener(
  'unhandledrejection',
  (event) => {
    if (!isHttpClientApiError(event.reason)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (process.env.NODE_ENV === 'development') {
      console.warn('API request failed without local handler:', event.reason);
    }
  },
  true,
);

startApp();

function startApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<App />);
}

// 10-03-2026-4 build portal prod
